import { Unplug } from "lucide-react";
import { Button } from "../ui/button/index.js";
import { cn } from "../../lib/utils.js";

/** One destructive treatment for every channel disconnect action (WhatsApp, Messenger, Instagram). */
export function DisconnectChannelButton({
  label,
  busy = false,
  className,
  testId,
  onClick,
}: {
  label: string;
  busy?: boolean;
  className?: string;
  testId?: string;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn(
        "shrink-0 border-destructive/30 bg-error-muted text-destructive not-disabled:hover:border-destructive/45 not-disabled:hover:bg-error-muted not-disabled:hover:brightness-[0.98]",
        className,
      )}
      data-testid={testId}
      onClick={onClick}
      disabled={busy}
    >
      <Unplug className="size-3.5" aria-hidden="true" />
      {label}
    </Button>
  );
}
